<template>
  <div class="email_box">
    <div class="email_box--main">
      <slot></slot>
    </div>

    <div
      v-if="!hideFooter"
      class="email_box--footer flex flex-vertical-center flex-between"
      style="width: 100%"
    >
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "EmailBox",
  props: {
    hideFooter: {
      type: Boolean,
      default: false
    },
  },
};
</script>

<style
  lang="scss"
  scoped
>
@import "../../../styles/variables/variables";


.email_box {
  height: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 50px;
  gap: 0 0;
  grid-template-areas:
    "main"
    "footer";
}

.email_box--main {
  grid-area: main;
  overflow-y: auto;
    overflow-x: hidden;
    padding: 10px;
}

.email_box--footer {
  grid-area: footer;
    border-top: 1px solid $borderDark;
    padding: 10px;
}
</style>
